import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { clockIcon } from '../../icons';

export const OnlyAfterPremiumExpiration = () => (
  <ErrorWrapper icon={clockIcon}>Дождитесь окончания Премиум-публикации</ErrorWrapper>
);
